import React from "react";

function PageNotFound() {
  return (
    <div className="h-full w-full  items-center justify-center flex">
      <span className="flex">
        <p className=" text-red-500 text-7xl">404 </p>
      </span>
    </div>
  );
}

export default PageNotFound;
